import styled from 'styled-components';

export const ConnectedBannerInfo = styled.div`
  background: #f0f7ff;
  border: 1px solid #0b99e6;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 20px;
`;

export const ConnectedBannerType = styled.div`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  color: #0b99e6;
  margin-bottom: 4px;
`;

export const ConnectedBannerLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #121516;
`;

export const PlatformCheckboxContainer = styled.div`
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid #d3d8de;
  box-shadow: 0px 3px 5px #e9ecf1;
  margin-bottom: 20px;
  width: 100%;
  padding: 19px 20px;

  label {
    color: #4f5d68;
    font-size: 14px;
    font-weight: bold;
    padding-top: 0;
  }
`;

export const PlatformDescription = styled.div`
  color: #717478;
  font-size: 13px;
  margin-top: 10px;
`;
